export default function () {
  return [
    { key: 'id', label: "id" },
    { key: 'pixel', label: "pixel" },
    { key: 'pixelNumber', label: "pixelNumber" },
    { key: 'pixelToken', label: "pixelToken" },
    { key: 'agencyName', label: "agencyName" },
  ]
}
